import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentThirdModalType, setTypeOfAdditionalModal } from '../../../../features/modal/modalSlice';
import Loading from '../../../ui/Loading';
import { useMasterData } from '../../../../hooks/api/useMasterData';
import { clearPopulateSpecialPackageItem, Default, selectClientData, selectClientSpecialPackageItems, selectSelectedSpecialPackageId, setClearSelectedPackage, setPopulateSpecialPackageItem, setSelectedPackage, setSelectedPackageView } from '../../../../features/client/clientSlice';
import BasicSpecialPackageItem from '../../../common/items/BasicSpecialPackageItem';
import CustomizePackageItemModal from '../../../modals/Admin/CustomizePackageItemModal';
import { useClientModalBasicPackageUseMemo } from '../../../../hooks/use-memo/useClientModalBasicPackageUseMemo';
import ViewSelectedSpecialProduct from '../../../modals/Admin/ViewSelectedSpecialProduct';
import { GetSpecialPackageProducts, SelectedSpecialPackage } from '../../../../features/client/clientInterface';

export interface PackageCard {
    type: "basic" | "special";
    id: number;
    name: string;
    cups: number | null;
    amount: number | null;
    totalProduct: number | null;
    items: GetSpecialPackageProducts[] | null;
}

export default function ClientModalBasicPackage() {

    const specialPackageItems = useSelector(selectClientSpecialPackageItems)
    const selectedPackageId = useSelector(selectSelectedSpecialPackageId)
    const newClientForm = useSelector(selectClientData)
    const typeOfThirdModal = useSelector(selectCurrentThirdModalType);
    const dispatch = useDispatch()
    const { getBasicPackage, isLoadingGetBasicPackage, isErrorGetBasicPackage, errorMessageGetBasicPackage, getSpecialPackages, isLoadingGetSpecialPackages, isErrorGetSpecialPackages, errorMessageSpecialPackages } = useMasterData()
    const { packages, selectedPackageItem } = useClientModalBasicPackageUseMemo( getBasicPackage, getSpecialPackages, specialPackageItems, selectedPackageId)
    const isLoading = isLoadingGetBasicPackage || isLoadingGetSpecialPackages;
    const isError = isErrorGetBasicPackage || isErrorGetSpecialPackages;
    const errorMessage = errorMessageGetBasicPackage || errorMessageSpecialPackages;
    
    const handleViewPackage = ( selectedPackage: Default, type: 'special' | 'basic' ) => {
        if(!selectedPackage.id) return;
        if(!selectedPackage.name) return;

        dispatch(setSelectedPackageView({
            id: selectedPackage.id,
            name: selectedPackage.name,
        }))

        dispatch(setTypeOfAdditionalModal('viewDefaultPackage'));
    };

    const handleSelectPackage = (id: number, name: string, isChecked: boolean, items: GetSpecialPackageProducts[], pkgAmount: number | null) => {
        if (selectedPackageId === id) {
            dispatch(setClearSelectedPackage());
            dispatch(clearPopulateSpecialPackageItem());
            return;
        }
        const selectedPackage: SelectedSpecialPackage = {
            id, 
            name, 
            isChecked, 
            startDate: newClientForm.scheduleFrom, 
            startTime: newClientForm.startTime, 
            endDate: newClientForm.scheduleTo, 
            endTime: newClientForm.endTime, 
            depositAmount: pkgAmount ?? 0,
            depositDate: '',
            receiptNumber: '',
        }
        dispatch(setSelectedPackage(selectedPackage)) 
        dispatch(clearPopulateSpecialPackageItem()) 
        dispatch(setPopulateSpecialPackageItem(items)) 
    }

    return (
        <div className='space-y-2'>
            <div className='flex space-x-2 mb-1.5'>
                <p className='font-medium text-sm'>Basic Package: </p>
                {/* <p className='text-sm text-gray-500 italic'>* Pick 1</p> */}
            </div>
            <div className={`grid grid-cols-2 md:grid-cols-3 gap-3 px-1 w-full`}>
                { isLoading ? (
                    <div className='flex flex-col items-center space-y-2 rounded p-2 cursor-pointer transition-colors bg-white ring-1 ring-cbColor border-t-8 border-cbColor'>
                        <Loading setH={'h-[50px]'}/>
                    </div>
                ) : isError ? (
                    <div className='flex flex-col items-center space-y-2 rounded p-2 cursor-pointer transition-colors bg-white ring-1 ring-cbColor border-t-8 border-cbColor text-sm'>{errorMessage}</div>
                ) : (
                    <>
                        {packages.map((pkg) => {
                            // const pkgItem: GetSpecialPackageProducts[] = pkg?.items?.map((item) => ({ id: item.productID, name: item.productName })) ?? [];
                            const pkgItem: GetSpecialPackageProducts[] = pkg?.items ?? [];
                            const selectedPackageToView: Default = { id: pkg.id, name: pkg.name }
                            
                            return (
                                <BasicSpecialPackageItem
                                    key={pkg.id}
                                    pkg={pkg}
                                    pkgItem={pkgItem}
                                    selectedPackageToView={selectedPackageToView}
                                    handleSelectPackage={handleSelectPackage}
                                    handleViewPackage={handleViewPackage}
                                />
                            ) 
                        })}
                    </>
                )}
            </div>
            {typeOfThirdModal === 'viewSelectedSpecialProduct' && (
                <ViewSelectedSpecialProduct/>
            )}
            {typeOfThirdModal === 'viewUpdateSpecialPackageProduct' && (
                <CustomizePackageItemModal packageProduct={selectedPackageItem}/>
            )}
        </div>
    )
}
